import { useEffect, useState } from "react";
import { Button } from "@/components/ui/Button";
import { Modal } from "@/components/ui/Modal";
import { useRejectRequisition } from "../hooks/useRequisitions";

/**
 * „Odrzuć zapotrzebowanie" (powód opcjonalny) — okno ze strony zapotrzebowania, wspólne
 * z zbiorczym „Do zatwierdzenia" dyrektora.
 */
export function RequisitionRejectModal({
  requisitionId,
  open,
  onClose,
  onRejected,
}: {
  requisitionId: string;
  open: boolean;
  onClose: () => void;
  onRejected?: () => void;
}) {
  const rejectMutation = useRejectRequisition();
  const [rejectComment, setRejectComment] = useState("");

  useEffect(() => {
    if (!open) return;
    setRejectComment("");
    rejectMutation.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, requisitionId]);

  const handleReject = () => {
    rejectMutation.mutate(
      { id: requisitionId, comment: rejectComment },
      { onSuccess: () => { onRejected?.(); onClose(); } },
    );
  };

  return (
    <Modal open={open} onClose={onClose} title="Odrzuć zapotrzebowanie" size="sm">
      <div className="flex flex-col gap-4">
        <div>
          <label className="text-sm font-medium text-gray-700 dark:text-gray-300 block mb-1">
            Powód odrzucenia (opcjonalny)
          </label>
          <textarea
            className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
            rows={3}
            value={rejectComment}
            onChange={(e) => setRejectComment(e.target.value)}
            placeholder="Opisz powód odrzucenia..."
          />
        </div>
        {rejectMutation.isError && (
          <p className="text-sm text-red-600">Błąd odrzucenia. Spróbuj ponownie.</p>
        )}
        <div className="flex gap-3">
          <Button variant="danger" loading={rejectMutation.isPending} onClick={handleReject}>
            Odrzuć zapotrzebowanie
          </Button>
          <Button variant="secondary" onClick={onClose}>Anuluj</Button>
        </div>
      </div>
    </Modal>
  );
}
